import { Pipe, PipeTransform } from '@angular/core';
import { BudgetRequestStatusTypeEnum } from '@zaoblako/shared/modules/task/enum/budget.request.status.type.enum';
import { BudgetRequestStatusTypeEnumColor } from '@zaoblako/shared/modules/task/constants/budget.request.status.type.enum.color';

@Pipe({
  name: 'budgetRequestStatusTypeColor',
  standalone: true
})
export class BudgetRequestStatusTypeColorPipe implements PipeTransform {
  public transform(status: BudgetRequestStatusTypeEnum): string {
    return BudgetRequestStatusTypeEnumColor[status] || '#a1a1a1';
  }
}
